export default (values) => {

  const errors = {};

  if (!values.type) errors.type = true;
  if (!values.content) errors.content = true;

  return errors;
  
}